import { useQuery } from '@tanstack/react-query';

import { useEffect } from 'react';
import { fetchProject } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';
import { isIdNotRecognizedError } from '@/helpers/is-id-not-recognized-error';
import { useNavigateTo } from '@/routes/hooks/use-navigate-to';

export const useProject = (projectId: string | null) => {
  const navigateTo = useNavigateTo();

  const getProject = () => {
    if (!projectId) return;

    return fetchProject(projectId);
  };

  const query = useQuery({
    queryKey: [QueryKey.Project, projectId],
    queryFn: getProject,
    enabled: !!projectId,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.error && isIdNotRecognizedError(query.error)) {
      navigateTo.notFound();
    }
  }, [query.error, navigateTo]);

  return query;
};
